import posthog from 'posthog-js';

const POSTHOG_KEY = 'phc_BMCVbkqQ4Q1poofwk8s0tydgcgMaVRUJxrJjwCr14Q6';
const POSTHOG_HOST = 'https://eu.i.posthog.com';

export function initPostHog() {
  if (typeof window !== 'undefined') {
    posthog.init(POSTHOG_KEY, {
      api_host: POSTHOG_HOST,
      capture_pageview: false, // We handle this manually on route changes
      capture_pageleave: true,
    });
  }
  return posthog;
}
